import { useEffect, useState } from "react";
import { QuotaTableContainer } from "./quota-table.styles"; // Adjust the import path as needed
import { getQuotaDetails } from "./QuotaLambdaUtils";
import { Modal, Row, Select, Spin, Tabs, message } from "antd";
import { ReactComponent as CloseIcon } from "../../../assets/svgs/icons/close-icon.svg";
import { OwnerQuotaData, QuotaData } from "./QuotaTableType";
import { QuotaTableDetails } from "./QuotaTableDetails";
import { UserOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const { Option } = Select;

export const QuotaTable = () => {
  const [loading, setLoading] = useState(true);
  const [quotaData, setQuotaData] = useState<OwnerQuotaData[]>([]);
  const [quotaOwnerData, setQuotaOwnerData] = useState<QuotaData | null>(null);
  const [selectedOwner, setSelectedOwner] = useState<string>("");
  const [showQuotaTable, setShowQuotaTable] = useState<boolean>(true);
  const navigate = useNavigate();

  const handleOwnerChange = (value: string) => {
    setSelectedOwner(value);
  };

  useEffect(() => {
    getQuotaDetails()
      .then((resp: string) => {
        const data = JSON.parse(resp);
        const tempData: OwnerQuotaData[] = [];
        Object.entries(data).forEach(([key, value]) => {
          if (value) {
            // filter out empty data
            tempData.push({ owner_name: key, data: value });
          }
        });
        setQuotaData(tempData);
      })
      .catch((err) => {
        message.error("Failed to fetch quota data");
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });

  }, []);

  useEffect(() => {
    console.log(quotaData);
    if (quotaData.length > 0) {
      setQuotaOwnerData(quotaData[0].data);
      setSelectedOwner(quotaData[0]?.owner_name);
    }
  }, [quotaData]);

  useEffect(() => {
    const foundUser = quotaData.find(
      (user) => user.owner_name === selectedOwner
    );
    setQuotaOwnerData(foundUser?.data || null);
  }, [selectedOwner, quotaData]);
  const tabItems = [
    {
      label: <span>Usage By Data Owner</span>,
      key: "1",
      children: (
        <>
          {loading ? (
            <div className="loading_block">
              <Spin size="large" />
            </div>
          ) : (
            <>
              <Select
                style={{ width: 200 }}
                value={selectedOwner}
                className="quota_owner_select"
                onChange={handleOwnerChange}
              >
                <UserOutlined
                  style={{
                    position: "absolute",
                    left: 8,
                    top: "50%",
                    transform: "translateY(-50%)",
                    zIndex: 1, // Ensure the icon is above the select box
                  }}
                />
                {quotaData.map((user, index) => (
                  <Option key={index} value={user.owner_name}>
                    {user.owner_name}
                  </Option>
                ))}
              </Select>
              <Row gutter={[16, 16]}>
                <QuotaTableDetails quotaOwnerData={quotaOwnerData} />
              </Row>
            </>
          )}
        </>
      ),
    },
  ];

  const handleCancel = () => {
    setShowQuotaTable(false);
    navigate('/')
  };

  return (
    <QuotaTableContainer>
      <Modal
        centered
        open={showQuotaTable}
        onCancel={handleCancel}
        className="batch_modal create_batch_modal quota_modal"
        closeIcon={
          <CloseIcon key="CloseIcon" color="#ffffff" onClick={handleCancel} />
        }
        footer={null}
        style={{
          backgroundColor: "#36BDBE",
          width: "100%", // Adjust the width as per your need
          maxWidth: "100%", // Set maximum width if needed
        }}
      >
        <QuotaTableContainer>
          <div className="table-container">
            <div className="custom-tab-container">
              <Tabs
                defaultActiveKey="1"
                items={tabItems}
                key="1"
                className="custom-tabs"
              ></Tabs>
            </div>
          </div>
        </QuotaTableContainer>
      </Modal>
    </QuotaTableContainer>
  );
};
